import { render, staticRenderFns } from "./ClientPaymentsModal.vue?vue&type=template&id=0db76694&scoped=true"
import script from "./ClientPaymentsModal.vue?vue&type=script&lang=js"
export * from "./ClientPaymentsModal.vue?vue&type=script&lang=js"
import style0 from "./ClientPaymentsModal.vue?vue&type=style&index=0&id=0db76694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db76694",
  null
  
)

export default component.exports